export const primaryHeaderHeight = 48;
export const secondaryHeaderHeight = 40;
export const notActiveLinkIdleColor = (isHoveredLink: boolean, hoverOtherLinksColors:string, idleColor:string) => (
  isHoveredLink ? hoverOtherLinksColors : idleColor
);

export const getHeaderHeight = (isSecondaryHeaderEnabled:boolean) => (isSecondaryHeaderEnabled ? secondaryHeaderHeight + primaryHeaderHeight : primaryHeaderHeight);
